export function getCoverImage(coverImageMapData, publication) {
  if (!coverImageMapData) return {};
  let img = { image: "default.jpg" };
  const peridicalsImgs = getImagesByPeriodical(coverImageMapData, publication);
  if (peridicalsImgs?.length > 1) {
    const tmp = getImagesByCategory(
      peridicalsImgs,
      publication?.txCategories?.map((cat) => cat.en),
    );
    const categoryImgs = tmp.length > 0 ? tmp : peridicalsImgs;
    if (categoryImgs?.length > 0) {
      img = { ...categoryImgs[0] };
    }
  } else if (peridicalsImgs?.length === 1) {
    img = { ...peridicalsImgs[0] };
  }
  return img;
}

function isAnchorOrSpecial(publication) {
  const flag =
    publication.txSubCategories &&
    publication.txSubCategories.find(
      (subCat) => subCat.en?.includes("Anchor Report") || subCat.en?.includes("Special Report"),
    );
  return flag;
}

function hasCatgory(arr1, arr2) {
  for (let i = 0; i < arr1.length; i += 1) {
    if (arr2?.includes(arr1[i])) {
      return true;
    }
  }
  return false;
}
function getImagesByPeriodical(imageMap, publication) {
  if (isAnchorOrSpecial(publication)) return imageMap.filter((img) => img.periodical === "Anchor Report");
  const imagesByPeriodicals = [];
  const reportTitles = publication?.reportTitles?.map((obj) => obj.en);
  for (let i = 0; i < imageMap.length; i += 1) {
    if (reportTitles?.includes(imageMap[i].periodical)) {
      imagesByPeriodicals.push(imageMap[i]);
    }
  }
  return imagesByPeriodicals;
}

const getImagesByCategory = (images, categories) => images.filter((img) => hasCatgory(img.categories, categories));
